import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import "./index.css";
import zhCN from "antd/es/locale/zh_CN";
import App from "./App";
import * as serviceWorker from "./serviceWorker.ts";
import "./pages/myutils/request";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

ReactDOM.render(
  <BrowserRouter>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
